import {Avatar} from '@mui/material'

import {ReactComponent as CheckmarkIcon} from '@progyny/assets/images/checkmark.svg'
import {ReactComponent as RestartIcon} from '@progyny/assets/images/restart.svg'
import {ReactComponent as ThumbsUp} from '@progyny/assets/images/thumbs-up.svg'
import {ReactComponent as WaitingIcon} from '@progyny/assets/images/waiting-icon.svg'

export const AvatarWithRestart = () => {
  return (
    <Avatar
      sx={{
        width: 20,
        height: 20,
        position: 'relative',
        '&.MuiAvatar-root': {backgroundColor: 'transparent'},
      }}
    >
      <RestartIcon />
    </Avatar>
  )
}

export const AvatarWithOnlyCheckmark = () => {
  return (
    <Avatar
      sx={{
        width: 110,
        height: 110,
        bgcolor: '#EEEEF1',
        position: 'relative',
        mb: 4,
      }}
    >
      <CheckmarkIcon />
    </Avatar>
  )
}

export const AvatarWithThumbsUp = () => {
  return (
    <Avatar
      sx={{
        width: 110,
        height: 110,
        bgcolor: '#EEEEF1',
        position: 'relative',
        mb: 4,
      }}
    >
      <ThumbsUp />
    </Avatar>
  )
}

export const AvatarWithOnlyWaitingIcon = () => {
  return (
    <Avatar
      sx={{
        width: 110,
        height: 110,
        bgcolor: '#EEEEF1',
        position: 'relative',
        mb: 4,
      }}
    >
      <WaitingIcon />
    </Avatar>
  )
}
